module.exports = __webpack_public_path__ + "static/media/sun.e2f2e668.svg";